
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function ensureUserHasPlan(uid) {
  const userRef = doc(db, "users", uid);
  const snap = await getDoc(userRef);

  if (!snap.exists()) return;

  const data = snap.data();
  const now = new Date();
  const end = data.trialEnd?.toDate?.() || new Date(data.trialEnd);

  if (data.paymentStatus === "paid" && end > now) return;

  if (data.plan !== "free_trial") {
    const trialEnd = new Date(now.getTime() + 15 * 24 * 60 * 60 * 1000);
    await updateDoc(userRef, {
      plan: "free_trial",
      paymentStatus: "paid",
      trialStart: now,
      trialEnd,
    });
  }
}
